"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_TASK = exports.DELETE_TASK = exports.GET_TASKS = exports.UPDATE_TASK = exports.CREATE_TASK = exports.TASKS_FIELDS_FRAGMENT = void 0;
const client_1 = require("@apollo/client");
exports.TASKS_FIELDS_FRAGMENT = (0, client_1.gql) `
  fragment TasksFieldsFragment on Task {
    id
    name
    description
    status
    assignees {
      id
      email
    }
    createdAt
    updatedAt
    dueDate
    targetSubmissionType {
      id
      name
    }
    relatedSubmission {
      id
    }
    targetObject {
      ... on Property {
        id
        streetAddress
        fullAddress
        latitude
        longitude
      }
      ... on CustomMapGeometry {
        id
        label
        customMapId
      }
    }
  }
`;
exports.CREATE_TASK = (0, client_1.gql) `
  mutation CreateTask($data: CreateTaskInput!) {
    createTask(data: $data) {
      ...TasksFieldsFragment
    }
  }

  ${exports.TASKS_FIELDS_FRAGMENT}
`;
exports.UPDATE_TASK = (0, client_1.gql) `
  mutation UpdateTask($data: UpdateTaskInput!) {
    updateTask(data: $data) {
      ...TasksFieldsFragment
    }
  }

  ${exports.TASKS_FIELDS_FRAGMENT}
`;
exports.GET_TASKS = (0, client_1.gql) `
  query GetTasks($objectId: ID!, $objectType: ObjectType!) {
    tasks(objectId: $objectId, objectType: $objectType) {
      ...TasksFieldsFragment
    }
  }

  ${exports.TASKS_FIELDS_FRAGMENT}
`;
exports.DELETE_TASK = (0, client_1.gql) `
  mutation DeleteTask($id: ID!) {
    deleteTask(id: $id)
  }
`;
exports.GET_TASK = (0, client_1.gql) `
  query GetTask($id: ID!) {
    task(id: $id) {
      ...TasksFieldsFragment
    }
  }
`;
//# sourceMappingURL=data:application/json;base64,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